import {action, observable} from 'mobx';
import BigNumber from 'bignumber.js';
import BaseStore from './baseStore';

export type UnitType = 'USD' | 'BIG_BLIND';
export type GameType = 'REGULAR' | 'OMAHA' | 'SHORT';
class GameStore extends BaseStore {
  @observable unit: UnitType = 'USD';

  @observable bigBlind: number;

  @observable smallBlind: number;

  @observable gameMode: GameType;

  //! TODO
  @observable currencyId: string;

  @observable gameType: GameType;

  @observable isAllIn: string;

  @observable roomNumber: string;

  constructor() {
    super();
    this.isReady = true;
  }

  @action setCurrencyId(currencyId: string): void {
    this.currencyId = currencyId !== this.currencyId ? currencyId : this.currencyId; 
  }

  @action setGameType(gameType: GameType): void {
    this.gameType = gameType !== this.gameType ? gameType : this.gameType;
  }

  @action setIsAllIn(isAllIn: string): void {
    this.isAllIn = isAllIn !== this.isAllIn ? isAllIn : this.isAllIn;
  }

  @action setRoomNumber(roomNumber: string): void {
    this.roomNumber = roomNumber;
  }

  @action changeUnit(): void {
    if (this.unit === 'BIG_BLIND') {
      this.unit = 'USD';
    } else {
      this.unit = 'BIG_BLIND';
    }
    // this.unit = 'USD';
  }

  @action setBigBlind(bigBlind: number): void {
    this.bigBlind = bigBlind !== this.bigBlind ? bigBlind : this.bigBlind;
  }

  @action setSmallBlind(smallBlind: number): void {
    this.smallBlind = smallBlind !== this.smallBlind ? smallBlind : this.smallBlind;
  }

  @action setGameMode(gameMode: GameType): void {
    this.gameMode = gameMode !== this.gameMode ? gameMode : this.gameMode;
  }

  @action getDisplayValue(dollarValue: number): number {
    // convert value in USD unit to in BB unit
    BigNumber.config({
      DECIMAL_PLACES: 2,
      ROUNDING_MODE: BigNumber.ROUND_HALF_UP,
    });

    let divisor = 0;
    if (this.gameMode === 'SHORT' && this.unit === 'BIG_BLIND') {
      divisor = this.smallBlind;
    } else if (this.unit === 'BIG_BLIND') {
      divisor = this.bigBlind;
    } else {
      divisor = 1;
    }

    const bigDollarValue = new BigNumber(dollarValue);
    const bigDivisor = new BigNumber(divisor);
    const calculated = bigDollarValue.dividedBy(bigDivisor).dp(2).toNumber();
    return calculated;
  }

  @action getUSDValue(BBValue: number): number {
    // convert value in BB unit to in usd unit
    let multiplier = 0;
    if (this.gameMode === 'SHORT' && this.unit === 'USD') {
      multiplier = this.smallBlind;
    } else if (this.unit === 'USD') {
      multiplier = this.bigBlind;
    } else {
      multiplier = 1;
    }

    const bigBBValue = new BigNumber(BBValue);
    const bigMultiplier = new BigNumber(multiplier);
    const calculated = bigBBValue.multipliedBy(bigMultiplier).dp(2).toNumber();
    return calculated;
  }
}

export default GameStore;
